import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';

import { FullStoryService } from '@services/fullstory.service';
import { environment } from '@environments/environment';

import { QuotingFlowStore } from '../services/quoting-flow.store';

@Component({
  selector: 'hsc-confirmation-modal',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],
  template: `
    <bolt-modal
      [open]="qfStore.showConfirmationModal()"
      [heading]="'Continue to purchase (quote #' + qfStore.axiomQuoteState().number + ')'"
      primarybutton="Continue"
      tertiarybutton="Close"
      (bolt-modal-primary-button-click)="handleConfirmationModalClick(true)"
      (bolt-modal-tertiary-button-click)="handleConfirmationModalClick()"
    >
      <p class="bolt-body-md mb-0!">We'll take you to a different website to enter payment information.</p>
    </bolt-modal>
  `,
})
export class ConfirmationModal {
  readonly qfStore = inject(QuotingFlowStore);
  private readonly fullStoryService = inject(FullStoryService);

  handleConfirmationModalClick(continueToPurchase = false): void {
    this.qfStore.showConfirmationModal.set(false);
    if (continueToPurchase) {
      this.fullStoryService.event('Purchase Continued');
      window.open(`${environment.IUNGO_PORTAL_URL}/quotes/${this.qfStore.axiomQuoteState().id}`, '_blank');
    } else {
      this.fullStoryService.event('Purchase Cancelled');
    }
  }
}
